import { Application, Sprite, Text } from "pixi.js";
import Scene from "./Scene";
import gsap from "gsap";
import { ConfigParams } from "../GameConfig";
import i18next from "i18next";
import { TextCounterController } from "../services/TextCounterController";
import GlobalStore from "../services/GlobalStore";

type SceneJackpotHitProps = {
  app: Application;
  config: ConfigParams;
  name: string;
};

const STAGE = {
  width: 1920,
  height: 1080,
};

class SceneJackpotHit extends Scene {
  private showTimeline: gsap.core.Timeline | undefined;
  private hideTimeline: gsap.core.Timeline | undefined;

  private jpText: Text;
  private jpController: TextCounterController;
  private locationText: Text;
  private frame: Sprite;

  constructor({ app, config, name }: SceneJackpotHitProps) {
    super({
      app: app,
      name: name,
      bgVideoPath: config.jackpot_hit.video_path,
      bgImagePath: config.jackpot_hit.image_path,
    });

    const shade = Sprite.from(`jackpot-hit-shade`);
    this.contentContainer.addChild(shade);

    // const plonk = Sprite.from(`_plonk_hit`);
    // this.bgContainer.addChild(plonk);
    // plonk.zIndex = 1;

    const rays = Sprite.from(`jackpot-background-rays`);
    // rays.zIndex = 1;

    const title = Sprite.from(`jackpot-title`);
    title.anchor.set(0.5, 0.5);
    title.position.set(STAGE.width / 2 - 5, 222);

    const frame = Sprite.from(`jackpot-frame`);
    frame.anchor.set(0.5, 0.5);
    frame.position.set(STAGE.width / 2, STAGE.height / 2 + 32);
    this.frame = frame;

    for (const c of [rays, title, frame]) {
      this.contentContainer.addChild(c);
    }

    const fontFamily: string = "Avenir Next Condensed Demi Bold";
    const jpDef = config.jackpot_hit;

    const locText = new Text({
      text: "SANTO DOMINGO",
      style: {
        fontFamily: fontFamily,
        fontSize: 100,
        fill: "0xffffff",
        align: "center",
      },
    });
    locText.x = STAGE.width / 2;
    locText.y = 895;
    locText.anchor.set(0.5, 0.5);
    this.contentContainer.addChild(locText);
    this.locationText = locText;

    const jpText = new Text({
      text: "12345",
      style: {
        fontFamily: fontFamily,
        fontSize: jpDef.size,
        fill: jpDef.color,
        align: "center",
      },
    });
    jpText.x = jpDef.x;
    jpText.y = jpDef.y;
    jpText.anchor.set(0.5, 0.5);
    this.contentContainer.addChild(jpText);
    this.jpText = jpText;

    this.jpController = new TextCounterController({
      attachTo: jpText,
      startingValue: 0,
      jackpotMode: true,
      duration: jpDef.spin_duration,
      delay: jpDef.delay_show,
      formatter: (number) => {
        return new Intl.NumberFormat(i18next.language, {
          style: "currency",
          currency: "USD",
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }).format(number);
      },
    });
  }

  show(): void {
    super.show();

    console.log("Showing jackpot win");

    const jackpotData = GlobalStore.getJackpotHitData();
    if (jackpotData === null) {
      throw new Error("Invalid jackpot data");
    }

    if (this.hideTimeline) {
      this.hideTimeline.pause(0);
    }

    if (!this.showTimeline) {
      this.showTimeline = gsap.timeline({
        onStart: () => {
          this.jpText.alpha = 0;
          this.locationText.text = jackpotData.location;
        },
      });

      this.showTimeline
        .addLabel("start")
        .fromTo(
          this.frame,
          { alpha: 0 },
          { alpha: 1, ease: "sine.out", duration: 0.5 },
        )
        .fromTo(
          this.jpText,
          {
            alpha: 0,
          },
          {
            alpha: 1,
            onStart: (counter: TextCounterController) => {
              console.log("count");
              counter.countFromTo(0, jackpotData.value, counter.duration, 0);
            },
            onStartParams: [this.jpController],
            delay: this.jpController.delay,
            ease: "sine.out",
          },
        );
    }

    this.showTimeline.play(0);
  }

  hide(): void {
    this.hideInstant();
    return;
    // if (!this.hideTimeline) {
    //   this.hideTimeline = gsap.timeline();

    //   this.hideTimeline.addLabel("start").to(this.jpText, {
    //     alpha: 0,
    //     onComplete: (counter: TextCounterController) => {
    //       counter.stop();
    //       super.hide();
    //     },
    //     onCompleteParams: [this.jpController],
    //   });
    // }

    // this.hideTimeline.play(0);
  }

  hideInstant = (): void => {
    this.showTimeline?.pause(0);
    this.hideTimeline?.pause(0);

    super.hide();
  };
}

export default SceneJackpotHit;
